import React from "react";
import { ArrowRight, Check, Zap, Briefcase, Link2 } from "lucide-react";
import { Button } from "../../components/ui/Button";
import { IconChip } from "../../components/ui/IconChip";

export default function FreelancePromo() {

    const openWhatsAppSupport = () => {
        const phoneNumber = "33756958621"; // WhatsApp phone number in international format (without +)
        const message = encodeURIComponent("Hello, I'd like to request access to the sales network");
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

        window.open(whatsappUrl, "_blank");
    };


    return (
        <div className="min-h-screen bg-canvas font-sans">
            <div className="max-w-6xl mx-auto px-6 pt-10">
                {/* Hero */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                    <div>
                        <h1 className="font-display text-3xl md:text-5xl font-normal tracking-tight leading-tight text-ink">
                            Accelerated with our sales/agent network
                        </h1>
                        <p className="mt-4 text-ink-muted text-lg leading-relaxed max-w-xl">
                            We connect you with commission-based agents and sales partners who actively pitch your profil to their network, ensuring faster outreach and better matches.
                        </p>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <Button variant="accent" onClick={openWhatsAppSupport}>
                                Request access
                                <ArrowRight className="w-4 h-4" />
                            </Button>

                            <Button variant="secondary" onClick={openWhatsAppSupport}>
                                Learn more
                            </Button>
                        </div>

                        <div className="mt-8 grid grid-cols-2 gap-4 text-sm text-ink-muted">
                            <div className="flex items-start gap-3">
                                <IconChip icon={Check} className="h-10 w-10 shrink-0" />
                                <div>
                                    <div className="font-medium text-ink">Commission based</div>
                                    <div>We find the right persons for you, everything is commission-based</div>
                                </div>
                            </div>

                            <div className="flex items-start gap-3">
                                <IconChip icon={Zap} className="h-10 w-10 shrink-0" />
                                <div>
                                    <div className="font-medium text-ink">Fast outreach</div>
                                    <div>Our sales agents actively pitch candidates to your ICP.</div>
                                </div>
                            </div>

                            <div className="flex items-start gap-3">
                                <IconChip icon={Briefcase} className="h-10 w-10 shrink-0" />
                                <div>
                                    <div className="font-medium text-ink">Professional network</div>
                                    <div>Our sales have extensive networks to find the best matches.</div>
                                </div>
                            </div>

                            <div className="flex items-start gap-3">
                                <IconChip icon={Link2} className="h-10 w-10 shrink-0" />
                                <div>
                                    <div className="font-medium text-ink">Dedicated process</div>
                                    <div>We manage the entire outreach and hiring process for you.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-surface p-6 border border-border rounded-2xl">
                        <div className="">
                            <div className="text-sm text-ink">Why it's working for our clients</div>
                            <ul className="mt-3 list-disc pl-5 text-sm text-ink-muted space-y-2">
                                <li>Off-market opportunities not found on job boards.</li>
                                <li>Network and commission-based agents ensure direct introductions.</li>
                                <li>Fully manages network of sales and agents selected by Duckflow</li>
                            </ul>
                        </div>

                        <div className="mt-6 flex gap-3">
                            <Button variant="primary" onClick={openWhatsAppSupport}>
                                Contact Us
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
